(function (window, document) {
  const form = document.getElementById('product-option-form');

  // If no form is found, exit early.
  if (!form) return;

  const submitButton = form.querySelector('button[type="submit"]');
  const summaryContainer = form.querySelector('.product-option-form__summary');

  init();

  function init() {

    // disable the submit button on init
    initSubmitButton();

    // validate the form
    form.addEventListener('change', (event) => {
      validateForm(event.currentTarget);
    });

    // prevent summary from overlapping content
    preventSummaryOverlap();
    // adjust again after modal loads
    window.componentEvents.on('modal-change', (data) => {
      if (data.id === 'product-option-modal' && data.action === 'open') {
        preventSummaryOverlap();
      }
    });

    window.componentEvents.on('product-option-form-reset', initSubmitButton);
  }

  /**
   * Initialize Submit Button
   *
   * Init the form's submit button by disabling it until the user has filled out
   * the form. To support future steps toward progressive enhancement, we only
   * disable the button until javascript inits, keeping the button functional if
   * javascript is disabled.
   */
  function initSubmitButton() {
    submitButton.disabled = true;
  }

  /**
   * Form Validation
   *
   * Verify that the user has filled out all the required fields in the form
   * before enabling the submit button.
   */
  function validateForm() {
    // We evaluate radio, file, and select inputs separately from all others.
    const radios = Array.from(form.querySelectorAll('input[type="radio"][required]'));
    const files = Array.from(form.querySelectorAll('input[type="file"][required]'));
    const selects = Array.from(form.querySelectorAll('select[required]'));
    const inputs = Array.from(form.querySelectorAll('input[required]:not([type="radio"]):not([type="file"])'));
    // Validity is determined by testing that all of the following are true:
    // - At least *one* required radio button is checked.
    // - *All* required file inputs have files selected.
    // - *All* required select drop downs have an option selected with a
    //   `value` attribute.
    // - *All* other required inputs are checked.
    const valid = radios.some((radio) => radio.checked) &&
      files.every((file) => file.files.length) &&
      selects.every((select) => select.querySelector('option:checked').getAttribute('value') !== null) &&
      inputs.every((input) => input.checked);

    if (valid) {
      submitButton.disabled = false;
    }
  }

  /**
   * Prevent Summary Overlap
   *
   * Keep the summary portion from overlapping the form by adding extra padding
   * to the bottom of the fieldset.
   */
  function preventSummaryOverlap() {
    // Get the height to add. Because of the overlap in the design, also add the
    // submitButton's height
    const summaryHeight = summaryContainer.offsetHeight + submitButton.offsetHeight;

    // Add the height as padding on the bottom of the fieldset
    form.querySelector('fieldset').style.paddingBottom = `${summaryHeight}px`;
  }

})(window, document);
